/* ---------- ortak overlay gözlemcisi ----------
 * Drawer / mobil menü / modal açıkken <html data-overlay-open> işaretlenir.
 * Product Quiz ve Campaign Strip CSS'i bunu okuyup kendini gizler.
 * İki component de aynı kodu taşır; global bayrak sayesinde yalnızca biri çalışır,
 * yani tek section kurulu olsa da çalışır, ikisi birlikteyse çift gözlemci olmaz.
 *
 * Tema class adı tahmin etmek yerine davranışa bakılır: neredeyse her drawer
 * body scroll'unu kilitler. Bilinen selector'lar ikinci savunma hattı.
 */
(function () {
  if (window.__themeOverlayWatch) return;
  window.__themeOverlayWatch = true;

  const SELECTORS = [
    'cart-drawer[open]',
    'cart-drawer.active',
    'cart-notification.active',
    '.drawer.is-open',
    '.drawer--is-open',
    '.drawer.active',
    '[data-drawer].is-open',
    '.menu-drawer[open]',
    'details[open] > .menu-drawer',
    '#CartDrawer.active',
    '.modal--is-active',
    '.modal.is-open',
    '.overlay.is-visible',
    'dialog[open]',
  ].join(',');

  const scrollLocked = () => {
    const b = getComputedStyle(document.body);
    const h = getComputedStyle(document.documentElement);
    // overflowY'ye bakılır: birçok tema body/html'e global overflow-x: hidden verir,
    // shorthand'e bakmak yanlış pozitif üretirdi.
    return (
      b.overflowY === 'hidden' ||
      b.position === 'fixed' ||
      h.overflowY === 'hidden' ||
      document.body.classList.contains('js-drawer-open') ||
      document.body.classList.contains('overflow-hidden') ||
      document.body.classList.contains('no-scroll')
    );
  };

  let last = null;
  const sync = () => {
    let open = scrollLocked();
    if (!open) {
      try {
        open = !!document.querySelector(SELECTORS);
      } catch (e) {
        open = false;
      }
    }
    if (open === last) return;
    last = open;
    if (open) document.documentElement.setAttribute('data-overlay-open', '1');
    else document.documentElement.removeAttribute('data-overlay-open');
  };

  const schedule = () => requestAnimationFrame(sync);

  new MutationObserver(schedule).observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['class', 'style'],
  });
  new MutationObserver(schedule).observe(document.body, {
    attributes: true,
    attributeFilter: ['class', 'style'],
  });

  // Drawer açılışları kullanıcı eylemiyle olur; animasyon bitince tekrar bak.
  ['click', 'keydown', 'transitionend'].forEach((ev) =>
    document.addEventListener(ev, () => {
      schedule();
      setTimeout(sync, 350);
    }, true)
  );

  sync();
})();

/* Ürün Quiz — global popup web component
 * State: 'intro' | number (soru index) | 'result'
 * Skorlama: cevaplardan toplanan etiketler ∩ aday etiketleri
 */
(function () {
  const DISMISS_PREFIX = 'pq:dismissed:';

  const ICONS = {
    droplet: ['M12 3s6 6.4 6 10.5A6 6 0 0 1 6 13.5C6 9.4 12 3 12 3z'],
    coffee: ['M5 8h11v4a4 4 0 0 1-4 4H9a4 4 0 0 1-4-4V8z', 'M16 9h2.5a2 2 0 0 1 0 4H16', 'M8 3v2M11 3v2'],
    shot: ['M7 4h10l-1.1 14.4a2 2 0 0 1-2 1.6h-3.8a2 2 0 0 1-2-1.6L7 4z', 'M7.8 11.5h8.4'],
    salad: ['M4 11h16a8 8 0 0 1-8 8 8 8 0 0 1-8-8z', 'M12 11a5 5 0 0 1 5-5', 'M12 11a4 4 0 0 0-4-4'],
    leaf: ['M5 19c0-8 6-13 14-14 0 8-5 14-13 14', 'M5 19c3-4 6-7 10-9'],
    flame: ['M12 3c2 3.5 5 5.2 5 9a5 5 0 0 1-10 0c0-2 1-3.4 2-4.5.3 1.2 1 2 2 2 0-2.5 1-5 1-6.5z'],
    sparkle: ['M12 3l1.9 5.1L19 10l-5.1 1.9L12 17l-1.9-5.1L5 10l5.1-1.9L12 3z'],
    bag: ['M6 7h12l-1 13H7L6 7z', 'M9 7a3 3 0 0 1 6 0'],
  };

  const esc = (s) =>
    String(s == null ? '' : s).replace(/[&<>"']/g, (c) =>
      ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c])
    );

  const icon = (name, cls) => {
    const d = ICONS[name] || ICONS.droplet;
    return `<svg class="${cls}" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"
      stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${d
      .map((p) => `<path d="${p}"/>`)
      .join('')}</svg>`;
  };

  const parseTags = (v) =>
    String(v || '')
      .split(',')
      .map((t) => t.trim().toLowerCase())
      .filter(Boolean);

  class ProductQuiz extends HTMLElement {
    connectedCallback() {
      const cfgEl = this.querySelector('[data-quiz-config]');
      if (!cfgEl) return;
      try {
        this.cfg = JSON.parse(cfgEl.textContent);
      } catch (e) {
        console.warn('[product-quiz] geçersiz config', e);
        return;
      }
      if (!this.cfg.questions || !this.cfg.questions.length) return;

      this.L = this.cfg.labels || {};
      this.signature = this.dataset.signature || 'default';
      this.rememberClose = this.dataset.rememberClose === 'true';
      this.dismissible = this.dataset.dismissible === 'true';

      this.state = { step: 'intro', answers: [], resultIdx: 0 };
      this.dismissed = this.rememberClose && this.isDismissed();

      this.build();

      // Tema editörü: blok seçilince ilgili soruya atla
      document.addEventListener('shopify:block:select', this.onBlockSelect);
      document.addEventListener('shopify:section:select', this.onSectionSelect);
      document.addEventListener('shopify:section:deselect', this.onSectionDeselect);
    }

    disconnectedCallback() {
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
      document.removeEventListener('shopify:section:select', this.onSectionSelect);
      document.removeEventListener('shopify:section:deselect', this.onSectionDeselect);
    }

    /* ---------- dismiss hafızası ---------- */
    key() {
      return DISMISS_PREFIX + this.signature;
    }
    isDismissed() {
      try {
        return localStorage.getItem(this.key()) === '1';
      } catch (e) {
        return false;
      }
    }
    setDismissed() {
      try {
        localStorage.setItem(this.key(), '1');
      } catch (e) {
        /* private mode */
      }
    }

    /* ---------- DOM iskeleti ---------- */
    build() {
      const pos = this.dataset.position === 'left' ? 'pq-fab--left' : 'pq-fab--right';
      const fabLabel = this.dataset.fabLabel || '';
      this.insertAdjacentHTML(
        'beforeend',
        `
        <div class="pq-fab ${pos}" data-fab ${this.dismissed ? 'hidden' : ''}>
          <button type="button" class="pq-fab__btn" data-open aria-label="${esc(fabLabel || this.L.title || 'Quiz')}">
            ${icon(this.dataset.fabIcon || 'droplet', 'pq-fab__icon')}
            ${fabLabel ? `<span class="pq-fab__label">${esc(fabLabel)}</span>` : ''}
          </button>
          ${
            this.dismissible
              ? `<button type="button" class="pq-fab__close" data-dismiss aria-label="${esc(this.L.close)}">
                   <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>
                 </button>`
              : ''
          }
        </div>
        <dialog class="pq-dialog" data-dialog>
          <div class="pq-dialog__inner">
            <button type="button" class="pq-dialog__close" data-close aria-label="${esc(this.L.close)}">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>
            </button>
            ${this.L.title ? `<h2 class="pq-dialog__title">${esc(this.L.title)}</h2>` : ''}
            <div data-body></div>
          </div>
        </dialog>`
      );

      this.fab = this.querySelector('[data-fab]');
      this.dialog = this.querySelector('[data-dialog]');
      this.body = this.querySelector('[data-body]');

      this.addEventListener('click', this.onClick);
      this.addEventListener('input', this.onInput);
      this.dialog.addEventListener('close', () => this.fab?.toggleAttribute('hidden', this.dismissed));
      this.dialog.addEventListener('click', (e) => {
        if (e.target === this.dialog) this.dialog.close(); // backdrop
      });

      this.render();
    }

    open() {
      this.render();
      if (typeof this.dialog.showModal === 'function') this.dialog.showModal();
      else this.dialog.setAttribute('open', '');
      this.fab?.setAttribute('hidden', '');
    }

    /* ---------- olaylar ---------- */
    onClick = (e) => {
      const t = e.target.closest('[data-open],[data-close],[data-dismiss],[data-choose],[data-next],[data-back],[data-restart],[data-cycle],[data-add]');
      if (!t) return;

      if (t.hasAttribute('data-open')) return this.open();
      if (t.hasAttribute('data-close')) return this.dialog.close();
      if (t.hasAttribute('data-dismiss')) {
        this.dismissed = true;
        this.fab.setAttribute('hidden', '');
        if (this.rememberClose) this.setDismissed();
        return;
      }
      if (t.hasAttribute('data-choose')) {
        const qi = Number(t.dataset.q);
        this.state.answers[qi] = { type: 'single', optionIndex: Number(t.dataset.choose) };
        return this.goNext(qi);
      }
      if (t.hasAttribute('data-next')) return this.goNext(Number(t.dataset.next));
      if (t.hasAttribute('data-back')) {
        const qi = Number(t.dataset.back);
        this.state.step = qi <= 0 ? 'intro' : qi - 1;
        return this.render();
      }
      if (t.hasAttribute('data-restart')) {
        this.state = { step: 'intro', answers: [], resultIdx: 0 };
        return this.render();
      }
      if (t.hasAttribute('data-cycle')) {
        const total = this.results().length;
        this.state.resultIdx = (this.state.resultIdx + 1) % total;
        return this.render();
      }
      if (t.hasAttribute('data-add')) return this.addToCart(t);
    };

    onInput = (e) => {
      const el = e.target.closest('[data-slider]');
      if (!el) return;
      const qi = Number(el.dataset.slider);
      this.state.answers[qi] = { type: 'slider', value: Number(el.value) };
      const hint = this.querySelector('[data-band-hint]');
      const band = this.activeBand(this.cfg.questions[qi], Number(el.value));
      if (hint) {
        hint.textContent = band?.hint || '';
        hint.toggleAttribute('hidden', !band?.hint);
      }
    };

    goNext(qi) {
      const q = this.cfg.questions[qi];
      if (q && q.type === 'slider' && !this.state.answers[qi]) {
        this.state.answers[qi] = { type: 'slider', value: 50 };
      }
      this.state.step = qi >= this.cfg.questions.length - 1 ? 'result' : qi + 1;
      this.state.resultIdx = 0;
      this.render();
    }

    /* ---------- skorlama ---------- */
    activeBand(q, value) {
      return (q.bands || [])
        .slice()
        .sort((a, b) => (a.upTo || 0) - (b.upTo || 0))
        .find((b) => value <= (b.upTo ?? 100));
    }

    collectTags() {
      const out = [];
      this.cfg.questions.forEach((q, qi) => {
        const a = this.state.answers[qi];
        if (!a) return;
        if (a.type === 'single') {
          out.push(...parseTags(q.options?.[a.optionIndex]?.tags));
        } else {
          out.push(...parseTags(this.activeBand(q, a.value)?.tags));
        }
      });
      return out;
    }

    results() {
      if (this._resultsCache && this._resultsCacheKey === JSON.stringify(this.state.answers)) {
        return this._resultsCache;
      }
      const tags = this.collectTags();
      const total = tags.length || 1;
      const scored = (this.cfg.candidates || []).map((c, i) => {
        const ct = parseTags(c.tags);
        const matched = tags.filter((t) => ct.includes(t)).length;
        return { candidate: c, matched, order: i, pct: Math.round((matched / total) * 100) };
      });
      scored.sort((a, b) => b.matched - a.matched || a.order - b.order);
      const out = scored.filter((s) => s.matched > 0).slice(0, this.cfg.maxResults || 3);
      this._resultsCache = out.length ? out : scored.slice(0, this.cfg.maxResults || 3);
      this._resultsCacheKey = JSON.stringify(this.state.answers);
      return this._resultsCache;
    }

    /* ---------- render ---------- */
    render() {
      const s = this.state.step;
      this.body.innerHTML =
        s === 'intro' ? this.renderIntro() : s === 'result' ? this.renderResult() : this.renderQuestion(s);
      this.body.firstElementChild?.classList.add('pq-enter');
    }

    renderIntro() {
      return `
        <div class="pq-intro">
          <div class="pq-intro__icon">${icon('droplet', 'pq-icon-lg')}</div>
          <div class="pq-intro__title">${esc(this.L.introTitle)}</div>
          ${this.L.introDesc ? `<p class="pq-intro__desc">${esc(this.L.introDesc)}</p>` : ''}
          <button type="button" class="pq-btn pq-btn--block" data-next="-1">${esc(this.L.start)}</button>
        </div>`;
    }

    renderQuestion(qi) {
      const q = this.cfg.questions[qi];
      const a = this.state.answers[qi];
      const isSlider = q.type === 'slider';
      const val = a?.type === 'slider' ? a.value : 50;
      const band = isSlider ? this.activeBand(q, val) : null;

      const progress = this.cfg.questions
        .map((_, i) => `<span class="pq-progress__bar${i <= qi ? ' is-on' : ''}"></span>`)
        .join('');

      const bodyHtml = isSlider
        ? `<div class="pq-slider">
             <div class="pq-slider__labels"><span>${esc(q.sliderLeft)}</span><span>${esc(q.sliderRight)}</span></div>
             <input type="range" min="0" max="100" value="${val}" data-slider="${qi}" class="pq-slider__input" aria-label="${esc(q.label)}">
             <div class="pq-hint" data-band-hint ${band?.hint ? '' : 'hidden'}>${esc(band?.hint || '')}</div>
           </div>`
        : `<div class="pq-options">${(q.options || [])
            .map((opt, oi) => {
              const on = a?.type === 'single' && a.optionIndex === oi;
              const media = opt.image
                ? `<img src="${esc(opt.image)}" alt="" loading="lazy" width="36" height="36">`
                : icon(opt.icon, 'pq-icon-sm');
              return `<button type="button" class="pq-option${on ? ' is-selected' : ''}" data-choose="${oi}" data-q="${qi}">
                        <span class="pq-option__media">${media}</span>
                        <span class="pq-option__label">${esc(opt.label)}</span>
                        ${on ? `<span class="pq-option__check">✓</span>` : ''}
                      </button>`;
            })
            .join('')}</div>`;

      return `
        <div class="pq-question">
          <div class="pq-progress">${progress}</div>
          <div class="pq-question__meta">${esc(this.L.questionWord)} ${qi + 1} · ${esc(
            isSlider ? this.L.sliderWord : this.L.singleWord
          )}</div>
          <div class="pq-question__label">${esc(q.label)}</div>
          ${bodyHtml}
          <div class="pq-nav">
            <button type="button" class="pq-link" data-back="${qi}">${esc(this.L.back)}</button>
            ${isSlider ? `<button type="button" class="pq-btn pq-btn--sm" data-next="${qi}">${esc(this.L.next)}</button>` : ''}
          </div>
        </div>`;
    }

    renderResult() {
      const list = this.results();
      if (!list.length) return `<div class="pq-empty">${esc(this.L.empty)}</div>`;
      const cur = list[Math.min(this.state.resultIdx, list.length - 1)];
      const c = cur.candidate;

      const features = (c.features || [])
        .map((f) => {
          const val =
            f.dots > 0
              ? `<span class="pq-dots">${Array.from({ length: 5 })
                  .map((_, d) => `<span class="pq-dot${d < f.dots ? ' is-on' : ''}"></span>`)
                  .join('')}</span>`
              : `<span class="pq-feature__value">${esc(f.value)}</span>`;
          return `<div class="pq-feature"><span class="pq-feature__label">${esc(f.label)}</span>${val}</div>`;
        })
        .join('');

      const label = c.ctaLabel || this.L.cta;
      const href = c.ctaUrl || c.url;
      const cta =
        c.ctaAction === 'add' && c.variantId && c.available
          ? `<button type="button" class="pq-btn pq-btn--block" data-add="${c.variantId}">${esc(label)}</button>`
          : `<a class="pq-btn pq-btn--block" href="${esc(href)}">${esc(label)}</a>`;

      return `
        <div class="pq-result">
          ${
            c.image
              ? `<div class="pq-result__media"><img src="${esc(c.image)}" alt="${esc(c.title)}" loading="lazy"></div>`
              : `<div class="pq-result__media pq-result__media--empty">${icon('sparkle', 'pq-icon-lg')}</div>`
          }
          <div class="pq-result__meta">${esc(this.L.resultPrefix)} · ${cur.pct}% ${esc(this.L.matchWord)}</div>
          <div class="pq-result__title">${esc(c.title)}</div>
          ${features ? `<div class="pq-features">${features}</div>` : ''}
          ${cta}
          <div class="pq-nav pq-nav--center">
            ${
              list.length > 1
                ? `<button type="button" class="pq-link" data-cycle>${esc(this.L.second)} (${this.state.resultIdx + 1}/${list.length})</button>`
                : ''
            }
            <button type="button" class="pq-link" data-restart>${esc(this.L.restart)}</button>
          </div>
        </div>`;
    }

    /* ---------- sepete ekle ---------- */
    async addToCart(btn) {
      const id = btn.dataset.add;
      const original = btn.textContent;
      btn.disabled = true;
      try {
        const res = await fetch(this.dataset.cartUrl || '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }),
        });
        if (!res.ok) throw new Error(await res.text());
        btn.textContent = this.L.addedToCart;
        // Dawn / OS2 tema uyumu
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.documentElement.dispatchEvent(new CustomEvent('cart:build'));
        setTimeout(() => {
          btn.textContent = original;
          btn.disabled = false;
        }, 1800);
      } catch (err) {
        console.warn('[product-quiz] sepete eklenemedi', err);
        btn.textContent = original;
        btn.disabled = false;
      }
    }

    /* ---------- tema editörü ---------- */
    onBlockSelect = (e) => {
      const id = e.detail?.blockId;
      const idx = this.cfg.questions.findIndex((q) => q.id === id);
      if (idx >= 0) {
        this.state.step = idx;
        this.open();
        return;
      }
      const cIdx = (this.cfg.candidates || []).findIndex((c) => c.id === id);
      if (cIdx >= 0) {
        this.state.step = 'result';
        this.state.resultIdx = 0;
        this.open();
      }
    };
    onSectionSelect = (e) => {
      if (e.detail?.sectionId === this.dataset.sectionId) this.open();
    };
    onSectionDeselect = (e) => {
      if (e.detail?.sectionId === this.dataset.sectionId) this.dialog?.close();
    };
  }

  if (!customElements.get('product-quiz')) customElements.define('product-quiz', ProductQuiz);
})();